// Unique symbol key so `[slottable]()` cannot collide with a public method name.
export const slottable = Symbol('slottable')
